import { Breakpoints } from '@hhgtech/hhg-components'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, MediaQuery, Stack } from '@mantine/core'

import { Container } from 'components/atoms/container'

import useStyles from './index.styles'
import { SingleBanner } from '../index.types'

type Props = {
  banner: SingleBanner['listing'][number]['banners'][number]
  // layout: SingleBanner['layout']
  layout: any
  layoutPosition: SingleBanner['layoutPosition']
} & BoxProps
export const SingleImage = ({
  layout,
  layoutPosition,
  banner,
  styles,
  className,
  classNames,
}: Props) => {
  const {
    desktop,
    mobile,
    title,
    titleColor,
    description,
    descriptionColor,
    buttons = {},
  } = banner
  const { classes, cx } = useStyles(
    { layout, layoutPosition },
    {
      name: 'CtaBannerSection__SingleImage',
      styles,
      classNames,
    },
  )
  return (
    <Box className={cx(className, classes.root)}>
      <Box className={classes.inner}>
        <Container className={classes.container}>
          <picture className={classes.picture}>
            <source
              media={`(min-width: ${Breakpoints.BREAK_POINT_TABLET}px)`}
              srcSet={desktop}
            />
            <img
              loading="lazy"
              src={mobile}
              alt="CTA Banner"
              width="100%"
              height="auto"
            />
          </picture>
          <Stack className={classes.info}>
            {(title || description) && (
              <Stack spacing={12} className={classes.header}>
                {title && (
                  <Text size="h1" as="h2" color={titleColor} variant="primary">
                    {title}
                  </Text>
                )}
                {description && (
                  <MediaQuery
                    smallerThan={'sm'}
                    styles={{
                      ...((layout === 'image_overlay_content' ||
                        layout === '2_column_layout_2_1') && {
                        display: 'none',
                      }),
                    }}
                  >
                    <Text
                      size="p2"
                      as="div"
                      variant="tertiary"
                      color={descriptionColor}
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    />
                  </MediaQuery>
                )}
              </Stack>
            )}
            {Object.keys(buttons).length > 0 && (
              <Box className={classes.actions}>
                {buttons?.primary?.url && buttons?.primary?.title && (
                  <Button
                    component={'a'}
                    {...{ href: buttons.primary.url }}
                    variant="secondary"
                    size="lg"
                    color={buttons.primary.backgroundColor}
                    styles={{
                      root: {
                        backgroundColor: '#fff',
                      },
                    }}
                  >
                    {buttons.primary.title}
                  </Button>
                )}
                {buttons?.secondary?.url && buttons?.secondary?.title && (
                  <Button
                    component={'a'}
                    {...{ href: buttons.secondary.url }}
                    variant="primary"
                    size="lg"
                    color={buttons.secondary.backgroundColor}
                  >
                    {buttons.secondary.title}
                  </Button>
                )}
              </Box>
            )}
          </Stack>
        </Container>
      </Box>
    </Box>
  )
}
